// extracted by mini-css-extract-plugin
module.exports = {"content":"TermsForBuyer_content__3mBgL"};